import { createFileRoute } from '@tanstack/react-router';

import { QuoteRequestTemplateCreatePage } from '@/areas/quote-requests/QuoteRequestTemplates/QuoteRequestTemplateCreatePage';
import { canManageSourcingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/quote-request/create')({
    staticData: { access: { permissions: canManageSourcingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <QuoteRequestTemplateCreatePage />;
}
